import organisationStructureDetails from "./organisationStructure.api";

const organisationStructureApi = {
  organisationStructureDetails,
};

export default organisationStructureApi;
